// src/pages/Dashboard/components/DashboardHeader.jsx
import React, { memo } from "react";

function DashboardHeader({ selectedProject }) {
  return (
    <>
      <h1 className="sd-title">
        {selectedProject?.projectName || "All Projects"} Safety Analytics
      </h1>
      <p className="sd-subtitle">
        {selectedProject
          ? `Location: ${selectedProject.siteLocation || "—"} | Status: ${
              selectedProject.status || "—"
            }`
          : "Enterprise HSE Dashboard"}
      </p>
    </>
  );
}

export default memo(DashboardHeader);
